module.exports = __webpack_public_path__ + "static/media/crocobig.6f3b227c.png";